import moment from 'moment';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '../../../../../components/Spinner';
import { useState } from 'react';
import { getDaysInMonth, previousYears } from '../../../../../utils/dates';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function ConsumerPopoverDateOfBirthForm({ consumerDateOfBirth, updateConsumer }) {
  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const [dateOfBirth, setDateOfBirth] = useState({
    year: String(moment(consumerDateOfBirth).year()),
    month: String(moment(consumerDateOfBirth).month()),
    date: String(moment(consumerDateOfBirth).date()),
  });

  const handleSave = async () => {
    setSpinner(true);
    await updateConsumer({
      dateOfBirth: moment({
        year: dateOfBirth.year,
        month: dateOfBirth.month,
        date: dateOfBirth.date,
      }).format('MM/DD/YYYY'),
    });
    setSpinner(false);
    setIsOpen(false);
  };

  const handleToggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Form.Label className="bo-consumer-input-label mt-3">Date of Birth</Form.Label>
      <OverlayTrigger
        trigger="click"
        placement="bottom-start"
        show={isOpen}
        popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 0] } }] }}
        overlay={
          <Popover className="custom-popover">
            <Popover.Body className="bo-consumer-popover-form-menu">
              <Spinner visible={spinner} size={36}>
                <Form.Label className="bo-consumer-popover-form-menu-label">Year</Form.Label>
                <Form.Select
                  className="bo-consumer-popover-form-menu-input bo-w-150"
                  value={dateOfBirth.year}
                  onChange={e => {
                    if (
                      !moment({
                        year: e.target.value,
                        month: dateOfBirth.month,
                        date: dateOfBirth.date,
                      }).isValid()
                    ) {
                      setDateOfBirth({
                        ...dateOfBirth,
                        year: e.target.value,
                        date: moment({ year: e.target.value, month: dateOfBirth.month })
                          .endOf('month')
                          .date(),
                      });
                    } else {
                      setDateOfBirth({ ...dateOfBirth, year: e.target.value });
                    }
                  }}
                >
                  {previousYears(100, moment().subtract(18, 'years').year()).map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Form.Select>
                <Form.Label className="bo-consumer-popover-form-menu-label mt-2">Month</Form.Label>
                <Form.Select
                  className="bo-consumer-popover-form-menu-input bo-w-150"
                  value={dateOfBirth.month}
                  onChange={e => {
                    if (
                      !moment({
                        year: dateOfBirth.year,
                        month: e.target.value,
                        date: dateOfBirth.date,
                      }).isValid()
                    ) {
                      setDateOfBirth({
                        ...dateOfBirth,
                        month: e.target.value,
                        date: moment({ year: dateOfBirth.year, month: e.target.value })
                          .endOf('month')
                          .date(),
                      });
                    } else {
                      setDateOfBirth({ ...dateOfBirth, month: e.target.value });
                    }
                  }}
                >
                  {[...Array(12)].map((_, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <option value={i} key={i}>
                      {moment().month(i).format('MMMM')}
                    </option>
                  ))}
                </Form.Select>
                <Form.Label className="bo-consumer-popover-form-menu-label mt-2">Day</Form.Label>
                <Form.Select
                  className="bo-consumer-popover-form-menu-input bo-w-150"
                  value={dateOfBirth.date}
                  onChange={e => setDateOfBirth({ ...dateOfBirth, date: e.target.value })}
                >
                  {getDaysInMonth(dateOfBirth.month, dateOfBirth.year).map(x => (
                    <option value={x} key={x}>
                      {x}
                    </option>
                  ))}
                </Form.Select>
                <div className="mt-2 d-flex justify-content-between">
                  <Button className="bo-common-button" onClick={handleSave}>
                    Save
                  </Button>
                  <Button className="bo-common-button" onClick={handleToggle}>
                    Cancel
                  </Button>
                </div>
              </Spinner>
            </Popover.Body>
          </Popover>
        }
      >
        <Button className="bo-consumer-text-input-container" onClick={handleToggle}>
          <div className="me-auto">
            <Form.Control
              className="bo-consumer-text-input bo-w-150"
              type="text"
              readOnly
              value={moment(consumerDateOfBirth).format('MMM DD, YYYY')}
            />
          </div>
          <div className="bo-consumer-input-button-container">
            <div className="bo-consumer-input-button-icon">
              <FontAwesomeIcon icon={faPencil} color="#5946A4" size="sm" />
            </div>
          </div>
        </Button>
      </OverlayTrigger>
    </>
  );
}

export default ConsumerPopoverDateOfBirthForm;
